import axios from '@/axios'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createEnum(context, enumData) {
    return new Promise((resolve, reject) => {
      axios
        .post('enums', enumData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countEnums(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`enums/count/?${query}`)
        .then(response => {
          context.commit('SET_ENUMS_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchEnums(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`enums/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_ENUMS', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  async fetchGeneralEnums(context) {
    const query = QuerySerialize({ groups: 'general' })
    try {
      const response = await axios.get(`enums/?${query}`)
      if (response) {
        context.commit('SET_GENERAL_ENUMS', response.data)
      }
    } catch (error) {
      notifyServerError(error)
    }
  },
  fetchEnum(context, enumKey) {
    return new Promise((resolve, reject) => {
      axios
        .get(`enums/${enumKey}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeEnum(context, enumId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`enums/${enumId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editEnum(context, enumData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`enums/${enumData.id}`, enumData.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
